import { ODataQueryController } from "../../controllers";
import { ComponentBase } from "../_ComponentBase";


/**
 * Shows a list of messages.
 * @example
 * ```html
 * <salaxy-message-thread-list limit-to="5" read-only="false"></salaxy-message-thread-list>
 * ```
 */
export class MessageThreadList extends ComponentBase {

  /**
   * The following component properties (attributes in HTML) are bound to the Controller.
   * For detailed functionality, refer to [controller](#controller) implementation.
   */
  public bindings = {

    /** Max count of threads to show in the list. */
    limitTo: "<",

    /** If readOnly is true, create buttons from the list view are hidden if readOnly property is supported */
    readOnly: "<",

    /**
     * URL for the approval view.
     */
    approvalUrl: "@",

  };

    /** Uses the ODataQueryController */
    public controller = ODataQueryController;

    /** The default template for the component. */
    public defaultTemplate = "salaxy-components/communications/MessageThreadList.html";

}
